<div class="list-header">
  <list-header class="width-15" [identifier]="'Identifier'" [sorting]="sorting" (sort)="onSort($event)"></list-header>
  <list-header class="width-35" [identifier]="'Location'" [sorting]="sorting" (sort)="onSort($event)"></list-header>
</div>
<cdk-accordion *ngIf="objects | async as locations">
  <cdk-accordion-item *ngFor="let location of locations; let index = index"
    #accordionItem="cdkAccordionItem" expanded="{{index == selection}}" role="button" tabindex="0" [attr.id]="'header-' + index">
    <div [class]="'list-item' + (selection == index ? ' selected' : '')" (click)="onToggle(accordionItem, index)">
      <span class="width-15">{{location.identifier}}</span>
      <span class="width-35">{{location.location | shorten:35}}</span>
    </div>
    <div *ngIf="accordionItem.expanded" role="region" [style.display]='' [attr.id]="'body-' + index">
      <app-location-form [object]="location" (event)="onEvent($event)" (objectChange)="onUpdate(index, $event)"></app-location-form>
    </div>
  </cdk-accordion-item>
</cdk-accordion>
